"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCheckableInputWrapper = exports.StyledCheckableInput = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldHelp = _interopRequireDefault(require("../field-help/field-help.style"));

var _formField = require("../form-field/form-field.style");

var _hiddenCheckableInput = _interopRequireDefault(require("./hidden-checkable-input.style"));

var _label = _interopRequireWildcard(require("../label/label.style"));

var _help = _interopRequireDefault(require("../../components/help/help.style"));

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _validationIcon = _interopRequireDefault(require("../validations/validation-icon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledCheckableInput = _styledComponents.default.div`
  display: inline-block;
  position: relative;
`;
exports.StyledCheckableInput = StyledCheckableInput;
const StyledCheckableInputWrapper = _styledComponents.default.div`
  ${({
  disabled,
  fieldHelpInline,
  inputWidth,
  labelWidth,
  labelInline,
  reverse,
  theme
}) => (0, _styledComponents.css)`
    ${_formField.FieldLineStyle} {
      display: flex;
    }

    ${_label.StyledLabelContainer} {
      ${labelInline && (0, _styledComponents.css)`
        justify-content: ${reverse ? "flex-start" : "flex-end"};
      `}
      padding-top: 0;
      width: auto;

      & ${_help.default}, & ${_validationIcon.default} {
        color: ${theme.help.color};
        vertical-align: middle;

        &:hover,
        &:focus {
          color: ${theme.text.color};
        }
      }
    }

    ${_fieldHelp.default} {
      flex-basis: 100%;
    }

    ${disabled && (0, _styledComponents.css)`
      ${_hiddenCheckableInput.default},
      ${_label.default} {
        &:hover,
        &:focus {
          outline: none;
          cursor: not-allowed;
        }
      }
    `}

    ${fieldHelpInline && (0, _styledComponents.css)`
      ${_formField.FieldLineStyle} {
        flex-wrap: nowrap;
      }

      ${StyledCheckableInput} {
        margin-right: 0;
        margin-left: 8px;
      }

      ${_fieldHelp.default} {
        flex-grow: 0;
        flex-basis: auto;
        padding-left: 0;
        width: auto;
      }
    `}

    ${reverse && fieldHelpInline && (0, _styledComponents.css)`
      ${StyledCheckableInput} {
        margin-left: 0;
      }

      ${_fieldHelp.default} {
        flex-grow: 1;
      }
    `}

    ${inputWidth !== undefined && inputWidth !== 0 && (0, _styledComponents.css)`
      ${StyledCheckableInput} {
        width: ${inputWidth}% !important;
      }
    `}

    ${labelWidth !== undefined && labelWidth !== 0 && `
      ${_label.StyledLabelContainer} {
        width: ${labelWidth}% !important;
      }
    `}
  `}
`;
exports.StyledCheckableInputWrapper = StyledCheckableInputWrapper;
StyledCheckableInputWrapper.propTypes = {
  disabled: _propTypes.default.bool,
  fieldHelpInline: _propTypes.default.bool,
  inputWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  labelWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  theme: _propTypes.default.object
};
StyledCheckableInputWrapper.defaultProps = {
  theme: _base.default
};